import Cohort from './Cohort';

export default Cohort;
